module.exports = __webpack_public_path__ + "img/Adam Neuhaus.9d4faf6b.png";